var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"map",style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.staticImageUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }